import { Result } from 'antd';
import { AButton } from '../../components';
import { useNavigate } from 'react-router-dom';

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Desculpe, Pagina não encontrada."
      extra={
        <AButton type="primary" onClick={() => navigate('/dashboard')}>
          Voltar para o Início
        </AButton>
      }
    />
  );
};

export default PageNotFound;
